import { useEffect } from 'react';

// Import static hero images used across cinematic context views
import scriptureHero from '@/assets/heroes/canonical_interweaving_hero_v2.png';
import timelineHero from '@/assets/heroes/ancient_writing_16_9_v4_1769312000000.png';
import adventureHero from '@/assets/heroes/sacred_rhythms_hero_v1.png';
import studyGuideHero from '@/assets/heroes/study_guide_hero_v3.png';
import pathwaysHero from '@/assets/heroes/reading_pathways_hero_v2.png';
import bookStructureHero from '@/assets/heroes/book_structure_hero_v2.png';
import archaeologyHero from '@/assets/archaeology-background.png';
import culturalSettingHero from '@/assets/cultural-setting-background.png';
import peopleHero from '@/assets/people-background.png';
import termsHero from '@/assets/terms-background.png';
import sensoryHero from '@/assets/sensory-background.png';
import scholarlyHero from '@/assets/scholarly-background.png';
import structureHero from '@/assets/heroes/structure_background_v3.png';
import toolsHero from '@/assets/literary-tools-background.png';

const HERO_IMAGES = [
    scriptureHero,
    timelineHero,
    adventureHero,
    studyGuideHero,
    pathwaysHero,
    bookStructureHero,
    archaeologyHero,
    culturalSettingHero,
    peopleHero,
    termsHero,
    sensoryHero,
    scholarlyHero,
    structureHero,
    toolsHero
];

/**
 * Hook to preload static hero images in the background.
 * This improves perceived performance when opening context panels.
 */
export function useHeroPreloader() {
    useEffect(() => {
        // Preload images only once
        const preloadImages = () => {
            HERO_IMAGES.forEach((src) => {
                const img = new Image();
                img.src = src;
            });
        };

        // Use requestIdleCallback if available to avoid impacting initial render
        if ('requestIdleCallback' in window) {
            (window as any).requestIdleCallback(() => preloadImages());
        } else {
            // Fallback to a short timeout
            setTimeout(preloadImages, 1000);
        }
    }, []);
}
